export class ConnectSourceAccountResponse {
    'sourceAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccount",
            "baseName": "sourceAccount",
            "type": "SourceAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
